import OrchestratorAPI from './common.js';
import { type Common } from '../common.js';
import { type JobKind } from '../models/orchestrator/job.js';
import {
  type CreateValues,
  type FindAllOptions,
  type JobConfig,
  type UpdateValues,
} from '../models/orchestrator/jobConfig.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/job-configs';

  baseEndpoint: string;

  constructor(common: Common) {
    super(common);
    this.baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;
  }

  async findAll(options: FindAllOptions = {}): Promise<JobConfig[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    const { jobConfigs } = await this.common.getJSON(url);
    return jobConfigs.map(this.deserialize);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<JobConfig>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAllKinds(): Promise<JobKind[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/kinds`);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<JobConfig> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { jobConfig } = await this.common.getJSON(url);
    return this.deserialize(jobConfig);
  }

  async create(values: CreateValues): Promise<JobConfig> {
    const url = this.common.constructPath(this.baseEndpoint);
    const { jobConfig } = await this.common.postJSON(url, values);
    return this.deserialize(jobConfig);
  }

  async update(id: string, values: UpdateValues): Promise<JobConfig> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { jobConfig } = await this.common.patchJSON(url, values);
    return this.deserialize(jobConfig);
  }

  async remove(id: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
